import {Theme} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ClassNameMap} from "@mui/styles";

export const useStyles: (theme: Theme) => ClassNameMap<'mainContainer' | 'filterContainer' | 'tabPanel' | 'actionButtonContainer' | 'radio' | 'topMargin' | 'mb'> = makeStyles((theme: Theme) => ({
  mainContainer: {
    paddingTop: '2.5rem',
    paddingBottom: '2.86rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '8.04rem',
      paddingRight: '8.04rem',
    }
  },
  filterContainer: {
    marginTop: '2em'
  },
  tabPanel: {
    paddingLeft: '0',
    paddingRight: '0',
  },
  actionButtonContainer: {
    padding: '0 0 1em 0'
  },
  radio: {
    marginLeft: "1rem"
  },
  topMargin: {
    marginTop: "1rem"
  },
  mb: {
    marginBottom: '1rem'
  }
}));